import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { OverlayTrigger, Form, Popover, Button, Row, Col, Tooltip, Modal } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { ProgressBar } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { format } from "date-fns";
import Icon from "@mdi/react";
import { mdiCheckCircleOutline, mdiFilter, mdiArrowLeft } from "@mdi/js";
import { financialYear } from "../../../config";
import * as adminDonationListAction from "../../../reducers/Admin/adminDonationListReducer";
import * as NotificationAction from "../../../reducers/notificationReducer";
import * as eventAction from "../../../reducers/eventReducer";
import "../AdminDonationsList/AdminDonationsList.scss";

import Loading from "../../../appComponents/Loading";
import Helpers, { asyncDownloadFile } from "../../../utils/helpers";
import Admin10BdBeUploadModal from "../Admin10BdBeDonations/Admin10BdBeUploadModal";
import Pagination from "../../../components/Pagination/Pagination";
import FilterByInput from "../../../components/FilterByInput";

const startOfFinancialYear2023 = new Date('2023-04-01T00:00:00.000Z');
const currentDate = new Date();
currentDate.setUTCHours(23, 59, 59, 999);

const tableHeading = [
  "S.No",
  "UIN(PAN of Donor)",
  "Donor",
  "Amount",
  "Certificate Status",
  "Approve Status",
];
class Admin10BdBeDonations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventList: [],
      onNonProfitsSelected : [],
      isAllItemsSelected:false,
      statsData : {},
      showPopover: false,

      showFailurefilesModal: false,
      errorMessage:[],
      ngoDataLoader: false,
      query: {
      },
      currentTab: 'export',
      filters: [
        {
          label: 'Search',
          type: [{
            type: 'default',
            label: 'Name',
            query: 'q',
          }, {
            type: 'pan',
            label: 'PAN Number',
            query: 'filter_by_pan',
          }, {
            type: 'email',
            label: 'Email',
            query: 'filter_by_user_email',
          }],
          placeholder: 'Search for Name, PAN, Email',
        },
        {
          label: 'Approve Status',
          type: 'list',
          query: 'filter_by_status',
          list: [{ label: 'Approved', value: 'approved' }, { label: 'Approval Pending', value: 'approval_pending' },{ label: 'All received', value: [] }],
          filterType: 'multiple'
        },
        {
          label: 'Certificate Status',
          type: 'list',
          query: 'filter_by_status',
          list: [{ label: 'Certificate Not Uploaded', value: 'pending' },{ label: 'Amount Matched', value: 'amount_matched' }, { label: 'Amount Mismatched', value: 'amount_mismatched' }, { label: 'All', value: [] }],
          filterType: 'multiple'
        },
      ],
      exportFilters: [],
      reportLinks: [],
      loader: false,
      isUploadModal: false,
      isUploading: false,
      downloadLoader: false,
      latestUploadedFile: {},
      latestUploadedFileStatus: '',
      name: "",
      uploadProgress:0,
      isExport10BDclicked: false
    };
  }


  componentDidMount() {
    const { donation, Donation, event, Event, match } = this.props;
    const { state } = this.props.location
    const { nonprofit, id } = match.params;
    const { query } = this.state
    const nonprofitId = (state?.nonprofit ? state.nonprofit : nonprofit) || state || id;
    this.setState({
      ngoDataLoader : true
    })
    Donation.getNonprofitDetails(nonprofitId).then((res) => {
      const { files_10be, latest_10be_status } = res || {}
      this.setState({
        latestUploadedFileStatus: latest_10be_status,
        name : res?.name
      })
      if (files_10be && files_10be.length > 0) {
        const latestFile = files_10be.find(item => item.fy === financialYear)?.zipUri || [];
        this.setState({ latestUploadedFile: latestFile })
      }
    })
    // if (!donation.get_status.donation10BdBe) {
      Donation.getDonations10bdbe(query, nonprofitId).then((res) => {
        this.setState({
          ngoDataLoader : false
        })
      });
    // }
    Donation.get10BDBeCertificatesStats(nonprofitId).then((res) => {
      this.setState({
        statsData : res
      })
    })
  }

  componentDidUpdate() {
    let updatedFilters = this.state.filters;
    if (this.state.eventList.length > 0) {
      for (let e = 0; e < updatedFilters.length; e++) {
        if (updatedFilters[e].label === "Event") {
          updatedFilters[e].list = this.state.eventList.map((list) => {
            return list[0];
          });
        }
      }

    }
  }
  componentWillUnmount() {
    const { Donation } = this.props;
    Donation.reset();
  }

  loadMore = () => {
    const { Donation, match } = this.props;
    const { query } = this.state;
    const { state } = this.props.location
    const { nonprofit, id } = match.params;
    const nonprofitId = (state?.nonprofit ? state.nonprofit : nonprofit) || state || id;
    this.setState({
      ngoDataLoader : true
    })
    Donation.getDonations10bdbe(query, nonprofitId).then(() => {
      this.setState({
        ngoDataLoader : false
      })
    });
  };
  
  refreshDonationsList = () => {
    const { Donation, match } = this.props;
    const { query } = this.state;
    const { state } = this.props.location
    const { nonprofit, id } = match.params;
    const nonprofitId = (state?.nonprofit ? state.nonprofit : nonprofit) || state || id;
    this.setState({
      ngoDataLoader: true
    })
    Donation.reset();
    Donation.getDonations10bdbe(query, nonprofitId).then(() => {
      this.setState({
        ngoDataLoader: false
      })
    });
  };


  filterOnChange = (filters) => {
    this.setState({ filters, query: Helpers.queryBuilderForFilterInput(filters) }, () => {
      this.refreshDonationsList()
    });
  };


  addToFilter = (type, value) => {
    const { filters } = this.state;
    const newOption = { ...filters.find((i) => i.label === type) };
    newOption.data = value;
    const newOptions = filters.map((item) => (item.label === type ? newOption : item));
    this.setState(
      { filters: newOptions, query: Helpers.queryBuilderForFilterInput(newOptions) }
    );
  };


  generateReportLink = (e, bdExportButton) => {
    e.preventDefault();
    this.setState({ loader: true })
    const { Donation, match } = this.props;
    const { state } = this.props.location
    const { id, nonprofit } = match.params;
    const nonprofitId = (state?.nonprofit ? state.nonprofit : id) || state || nonprofit;
    const isAllItemsSelected = this.state.isAllItemsSelected;
    const userPANs = isAllItemsSelected ? [] : this.state.onNonProfitsSelected;
    const params = {
      ...this.state.query,
      nonprofitId,
      userPANs
    }

    const bdExportBtn = bdExportButton ? true : undefined 
    Donation.generateReportLink10BdBe({ ...params }, bdExportBtn)?.then((data) => {
      if (data !== undefined) {
        const { match } = this.props
        const { state } = this.props.location
        const { nonprofit } = match.params;

        // const nonprofitId = state?.nonprofit ? state.nonprofit : nonprofit
        const nonprofitId = (state?.nonprofit ? state.nonprofit : id) || state || nonprofit
        const isAdmin = state?.nonprofit?.name && state?.nonprofit?.name.length > 0;
        const query = {
          is10BdBe: true,
          // nonprofitId: isAdmin ? nonprofitId : undefined
          nonprofitId: nonprofitId,
          bdExportButton: bdExportButton ? true : undefined
        }
        
        Donation.getReportLinks(query).then((reportsData) => {
          this.setState({ reportLinks: reportsData, currentTab: 'downloads', loader: false });
        });
      }
      else {
        this.setState({ currentTab: 'export', loader: false });
      }
    });
  };

  getReportLinks = (e, isExport, bdExportButton) => {
    e.preventDefault();
    const { Donation } = this.props;
    this.setState({
      loader: true
    })
    if (isExport) {
      this.setState({
        currentTab: isExport
      })
    }
    const { match } = this.props
    const { state } = this.props.location
    const { nonprofit, id } = match.params;

    const nonprofitId = (state?.nonprofit ? state.nonprofit : id) || state || nonprofit

    const isAdmin = state?.nonprofit?.name && state?.nonprofit?.name.length > 0;
    const query = {
      is10BdBe: true,
      // nonprofitId: isAdmin ? nonprofitId : undefined
      nonprofitId: nonprofitId,
      bdExportButton: bdExportButton ? true : undefined
    }
   
    Donation.getReportLinks(query).then((data) => {
      setTimeout(() => {
        this.setState({
          loader: false
        })
      }, 2000);
      this.setState({ reportLinks: data });
    });
  };

  addToFilterHTML = (type, value) => (
    <span className="filter-wrapper">
      <button
        type="button"
        className="btn btn-rounded btn-inverse-outline-primary btn-filters"
        onClick={(e) => {
          e.preventDefault();
          this.addToFilter(type, value);
        }}
      >
        <Icon path={mdiFilter} size={0.5} color="#2196f3" />
        <span>Apply as filter</span>
      </button>
    </span>
  );

  onTabChange = (e, tab, bdExportButton) => {
    this.setState({
      currentTab: tab
    })
    if (tab === 'downloads') {
      this.getReportLinks(e, 'downloads', bdExportButton)
    }
  };

  handleApproveNonprofit = () => {
    const { _id } = this.props.tileProps || {};
    const { Donation } = this.props || {};
    const { match } = this.props
    const { state } = this.props.location
    const { nonprofit } = match.params;
    const nonprofitId = (state?.nonprofit ? state.nonprofit : nonprofit) || state || match?.params?.id;
    const isAllItemsSelected = this.state.isAllItemsSelected;
    const userPANs = isAllItemsSelected ? [] : this.state.onNonProfitsSelected;
    const params = {
      ...this.state.query,
    }

    Donation.approveNonprofits(nonprofitId, userPANs, { ...params })
        .then((res) => {
          window.location.reload()
           // this.refreshDonationsList()
        })
        .catch((err) => {
        })
}

  handleUpload = (files) => {
    const { Donation } = this.props || {};
    this.setState({ isUploading: true })
    const csvFile = files?.find(file => file?.uploadedFile === "10beSheet")?.file;
    const zipFile = files?.find(file => file?.uploadedFile === "10beCertificateFolder")?.file;
    const { match } = this.props
    const { state } = this.props.location
    const { nonprofit } = match.params;
    const nonprofitId = (state?.nonprofit ? state.nonprofit : nonprofit) || state || match?.params?.id
    const query = {
      csvFile,
      zipFile,
      nonprofitId
    }
    // this.setState({uploadProgress : 0})
    // const interval = setInterval(() => {
    //   this.setState((prevState) => {
    //     // Increment progress, but do not exceed 90% to simulate progress
    //     const nextProgress = prevState.uploadProgress + 10;
    //     return { uploadProgress: nextProgress > 90 ? 90 : nextProgress };
    //   });
    // }, 500);
    Donation.upload10bdbe(query)
      .then(() => {
        // clearInterval(interval);
        this.setState({ isUploading: false, isUploadModal: false, showUploadedFiles: true,  uploadProgress: 100, })
        Donation.getNonprofitDetails(nonprofitId).then((res) => {
          const { files_10be, latest_10be_status } = res || {}
          this.setState({ latestUploadedFileStatus: latest_10be_status })
          if (files_10be && files_10be.length > 0) {
            const latestFile = files_10be.find(item => item.fy === financialYear)?.zipUri || [];
            this.setState({ latestUploadedFile: latestFile })
          }
        })
        Donation.get10BDBeCertificatesStats(nonprofitId).then((res) => {
          this.setState({
            statsData : res
          })
        })
      })
      .catch(() => this.setState({ isUploading: false }))

  }

  handleCloseOverlay = () => {
    this.setState({ isUploading: false, uploadProgress: 0 });
  };

  handleDownload = async (url, nameConvention) => {
    this.setState({ downloadLoader: true })
    try {
      await asyncDownloadFile(url, nameConvention);
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ downloadLoader: false })
    }
  };


  get10BEImports = (e) => {
    e.preventDefault();
    const { Donation } = this.props;
    this.setState({
      loader: true
    })
    const { match } = this.props
    const { state } = this.props.location
    const { nonprofit, id } = match.params;

    const nonprofitId = (state?.nonprofit ? state.nonprofit : id) || state || nonprofit
    const query = {
      nonprofitId: nonprofitId,
    }
    Donation.get10BEImports(query).then((data) => {
      setTimeout(() => {
        this.setState({
          loader: false
        })
      }, 2000);
      this.setState({ reportLinks: data?.data });
    });
  };


  handleImport10BEfiles = (index, failureFiles, filteredData) => {
    this.setState({ showFailurefilesModal: true, showPopover:false });
    let errorResponse = [];
    const filteredDataMapped = filteredData?.map(([key, value]) => <div>  {key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())} - {value}</div>)
    if(failureFiles && failureFiles.length > 0) {
      if (filteredData && filteredDataMapped?.length > 0) {
        errorResponse?.push(
          <span key={`filtered-${index}`}>
            <b>Imported file Info</b><br/> {filteredDataMapped}
          </span>
        );
      }

      errorResponse = [
        ...errorResponse,
        ...failureFiles?.map((failure, idx) => (
          <span key={idx}>
            <b>Error Reason:</b> {failure?.error_reason} <br/> 
            <b>FileName:</b> {failure?.file_name}
          </span>
        )),
      ];
      this.setState({
        errorMessage : errorResponse
      })
    } else {
      this.setState({
        errorMessage : []
      })
    }
  };
  

  BEImportsPopover = () => {
    const { reportLinks } = this.state;
    return (
      <Popover id="popover-basic-1">
        <Popover.Content>
          <Row>
            <Col md={12} xs={12} className="export-download">
              <ul className="nav nav-tabs tab-basic" role="tablist">
                <li className="nav-item">
                <a className={`${`nav-link active show`}`} id="download-tab" data-toggle="tab" href="#download">10BE Import files</a>
                </li>
              </ul>
              <div className="tab-content tab-content-basic">
                {
                <div className="tab-pane fade show active" style={{maxHeight:"400px", overflowY :"auto", display:"block", whiteSpace:"nowrap"}}>
                  <Col md={12} xs={12}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Requested</th>
                          <th>File Info</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(!reportLinks || reportLinks?.length === 0)  &&
                          <i className="align-center">No items available</i>}
                        {reportLinks && reportLinks?.length && reportLinks?.map((link, index) => {
                          const filteredData = link?.response && Object.entries(link?.response)?.filter(([key]) => key !== "failure_data");
                          return (
                            <><tr key={index}>
                              <td style={{ maxWidth: "100%", whiteSpace: "nowrap" }}>
                                <div className="download-tag-wrapper">
                                  <span className="download-tag">{format(new Date(link.created_at), "MMM do, yyyy HH:mm aa")}</span>
                                </div>
                              </td>
                              <td>
                                <div className="download-tag-wrapper">
                                  {['a'].map(item => (
                                    <>
                                      {link ? <>
                                        {link?.status === 'completed' ? filteredData && filteredData?.map(([key, value]) => (
                                          <span className="download-tag">  {key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())} - {value}</span>
                                        )) : <span className="download-tag">{link?._id}</span>}
                                      </> : ''}
                                    </>
                                  ))}
                                </div>
                              </td>
                              <td style={{width:"20%"}}>
                                <p
                                  className={`btn btn-xs ${(link?.status === "completed")
                                      ? "btn-success"
                                      : "disabled btn-secondary"}`}
                                  onClick={() => link?.status === "completed" && this.handleImport10BEfiles(index, link?.response?.failure_data, filteredData)}
                                >
                                  {link?.status === 'completed' ? "View Results" : link?.status}
                                </p>
                              </td>
                            </tr></>
                          )
                        })}
                      </tbody>
                    </table>
                  </Col>
                </div>}
              </div>
            </Col>
          </Row>
          <Row></Row>
        </Popover.Content>
      </Popover>
    );
  };

  popover = (bdExportButton) => {
    const { donation } = this.props;
    const { reportLinks } = this.state;
    // const fieldNames = {
    //   basic:
    //     "(createdAfter,createdBefore)",
    // };

    return (
      <Popover id="popover-basic-1">
        <Popover.Content>
          <Row>
            <Col md={12} xs={12} className="export-download">
              <ul className="nav nav-tabs tab-basic" role="tablist">
                <li className="nav-item">
                  <a className={`${`nav-link ${this.state.currentTab === 'export' ? `active` : ''} show`}`} id="export-tab" data-toggle="tab" href="#export" onClick={(e) => this.onTabChange(e, 'export')} >Export</a>
                </li>
                <li className="nav-item">
                  <a className={`${`nav-link ${this.state.currentTab === 'downloads' ? `active` : ''} show`}`} id="download-tab" data-toggle="tab" href="#download" onClick={(e) => this.onTabChange(e, 'downloads', bdExportButton ? "bdExportButton" : "")} >Downloads</a>
                </li>
              </ul>
              <div className="tab-content tab-content-basic">
                {
                  this.state.currentTab === 'export' ?
                    <div className="tab-pane fade show active">
                      <Col md={12} xs={12} className="export-filters">
                        <Popover.Title as="h3">Select Fields</Popover.Title>
                        <Form.Check className="popover-checkbox" type="checkbox" id="basic" label="Basic Details" disabled checked />
                        {/* <div className="popover-checkbox-div" htmlFor="basic">{fieldNames && fieldNames?.basic}</div> */}
                          <div className="text-center">
                          <Button className="btn btn-sm" 
                          // disabled={!this.state.onNonProfitsSelected.length > 0}
                          onClick={(e) => this.generateReportLink(e, bdExportButton ? "bdExportButton" : undefined)}>{donation.get_status.generate_report === '' ? 'Export to CSV' : donation.get_status.generate_report === 'pending' ? 'Generating...' : 'Export to CSV'}</Button>
                        </div> 
                      </Col>
                    </div> :
                    <div className="tab-pane fade show active" style={{maxHeight:"400px", overflowY :"auto", display:"block", whiteSpace:"nowrap"}}>
                      <Col md={12} xs={12}>
                        <Popover.Title as="h3">
                          <span>Queued for download</span>
                          <button type="button" className="btn btn-inverse-link" 
                          onClick={(e) => this.getReportLinks(e, "" , bdExportButton ? "bdExportButton" : "")}
                          >
                            <div className="export">
                              <div className={`${this.state.loader ? `export-loader-spin` : `export-loader`}`}></div>
                            </div>
                          </button>
                        </Popover.Title>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Requested</th>
                              <th>Tags</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(!reportLinks || reportLinks?.length === 0) &&
                              <i className="align-center">No items available</i>}
                            {reportLinks && reportLinks?.length && reportLinks.map((link, index) => {
                              // let filterAppl = link.queryParameter.filter;
                              return (
                                <tr key={index}>
                                  <td style={{ maxWidth: "100%", whiteSpace: "nowrap" }}>
                                    <div className="download-tag-wrapper">
                                      <span className="download-tag">{format(new Date(link.created_at), "MMM do, yyyy HH:mm aa")}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="download-tag-wrapper">
                                      {['a'].map(item => (
                                        <>
                                          {link ? <span className="download-tag">{link?.nonprofit_id}</span> : ''}
                                        </>
                                      ))}
                                    </div>
                                  </td>
                                  <td>
                                  <p
                                    className={`btn btn-xs ${
                                      (bdExportButton && link?.status === "active") || (!bdExportButton && link?.status === "completed")
                                        ? "btn-success"
                                        : "disabled btn-secondary"
                                    }`}
                                    onClick={() =>
                                      this.handleDownload(
                                        bdExportButton ? link?.file_uri : link?.dataLink,
                                        bdExportButton ? `${link?.nonprofit_slug}__${link?.nonprofit_pan_card}` : ''
                                      )
                                    }
                                  >
                                    {(bdExportButton && link?.status === "active") || (!bdExportButton && link?.status === "completed")
                                      ? "Download"
                                      : link?.status}
                                  </p>
                                </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </Col>
                    </div>}
              </div>
            </Col>
          </Row>
          <Row></Row>
        </Popover.Content>
      </Popover>
    );
  };

  donationsHTML = () => {
    const { donation } = this.props;
    const { donation10BdBe } = donation || {}
    if (
      !donation.get_status.donation10BdBe ||
      (donation.get_status.donation10BdBe === "pending" && donation10BdBe.length === 0)
    ) {
      return <Loading />;
    }
    if (donation10BdBe?.length === 0) {
      return <i className="align-center">No items available</i>;
    }
    return (
      <>
        {donation10BdBe.map((item, index) => (
          <li className="table-list-item" key={item.order_id}>
            <div className="row">
              <div className="col-md-12 table-col">
                <div className="row">
                  <div className="col-md col-12 table-col dl-mob">
                    {index + 1}
                  </div>
                  <div className="col-md col-12 table-col dl-mob">
                    -
                  </div>

                  <div className="col-md-2 col-12 table-col dl-mob">
                    <span>{item.user?.pan_card}</span>
                  </div>

                  <div className="col-md-2 col-12 table-col dl-mob">
                    <span>{
                      item?.nonprofit?.registration_date ? format(new Date(item?.nonprofit?.registration_date), 'do MMM yyyy') : null
                    }</span>
                  </div>

                  {item.user ? (
                    <div className="col-md-2 col-12 table-col dl-mob user-info-livedis">
                      <img alt="user" className="img-circle width-30" src={item.user.profile_pic} />
                      <div className="name-email">
                        <span>{item.user.name}</span>
                        <small>
                          {item.user.email}
                          {item.user.is_email_verified ? (
                            <Icon path={mdiCheckCircleOutline} size={0.75} color="#777777" />
                          ) : null}
                        </small>
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-2 col-12 table-col dl-mob user-info-livedis">
                      User Not Available
                    </div>
                  )}
                  <div className="col-md-2 col-12 table-col dl-mob">
                    <span>{item.user?.address?.formatted}</span>

                  </div>
                  <div className="col-md-1 col-12 table-col dl-mob-right">
                    INR {item.totalAmount}
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </>
    )

  };

   
  retrieveCheckedItems = (ngos) => {
    const formattedData = ngos.map((ngosData) => ngosData.user.pan_card);
    this.setState({ onNonProfitsSelected : formattedData }); 
  };


  handleOnAllItemsSelected = (value) => {
    this.setState({ isAllItemsSelected : value})
  }

  handleCloseProgressBar = () => {

  }

  anotherFunction = (value) => {
    this.setState({
      isExport10BDclicked : value
    })
  }


  render() {
    const { donation } = this.props;
    const { get_status, load_status } = donation || {}
    const { filters, fYears, query,statsData } = this.state;
    const { donation10BdBe: loadStatus } = get_status || ''
    const { state } = this.props.location
    const { isUploadModal, isUploading, downloadLoader, latestUploadedFile } = this.state;
    const { totalCount, donation10BdBe } = donation;
    return (
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div style={{display:"flex", alignItems:"baseline", flexDirection : isMobile ? "column-reverse" : "row"}}>
                <h3 className="mr-b-20">
                  {state?.nonprofit?.name &&
                    <Link to={`..`} ><Icon path={mdiArrowLeft} size={1} className="arrow-left" color="#333333" />
                    </Link>}<strong>
                    {`${state?.nonprofit?.name ? `${state?.nonprofit?.name} - ` : '10BD/BE '}`}
                  </strong>
                  Donations</h3>
                  <h5 style={{marginLeft: !isMobile && "20%"}}> {this.state.name}</h5>
                </div>
                {/* Parked for future use */}
                {/* <FilterByInput value={filters} onChange={this.filterOnChange} is10BdBe /> */}
                <div className="row">
                 
                </div>
                <div className="row justify-content-start">
                  <div className={`${isMobile ? "col-md-6 col-6 text-left" : "col-md-4 col-4 text-left"}`}>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => this.setState({ isUploadModal: true })}
                      >
                        Upload 10BE
                      </button>
                    { }
                    {/* removed csv */}
                    {latestUploadedFile &&
                      <div className="row mt-3">
                        <div className="col-16">
                        {latestUploadedFile && latestUploadedFile.length > 0 ? (
                          latestUploadedFile?.map((zipUri, index) => (
                          <p
                            key={index}
                            className={`${downloadLoader ? 'disabled-button' : ''} download-btn`}
                            onClick={() => this.handleDownload(zipUri)}
                          >
                            {`Download ZIP - ${zipUri}`}
                          </p>
                        ))
                      ) : (
                        <p>No files available to download.</p>
                      )}
                        </div>
                        <div className={`${!downloadLoader && 'd-none'} export col-4`}>
                          <div className={`${downloadLoader ? `export-loader-spin` : `export-loader`}`}></div>
                        </div>
                      </div>}
                  </div>
                  {
                    statsData ? 
                    <div className={`${isMobile ? "col-md-12 col-12 text-right bdbe_table" : "col-md-6 col-6 text-right bdbe_table"}`}>
                    <table  
                        border="1"
                        width="100%"
                        cellSpacing="0"
                        style={{
                          textAlign: "left",
                          minWidth: "700px",
                        }}>
                    <thead>
                      <tr>
                         <th >No of 10BD certificates expected</th>
                         <th >No of 10BE certificates uploaded</th>
                         <th >No of 10BE certificates with Amount_matched</th>
                         <th >No of 10BE certificates with Amount_mismatched</th>
                         <th >No of 10BE certificates with Pending</th>
                         <th >% 10BE Matching Certificates</th>
                         <th >Total 10BD Amount</th>
                         <th >Total 10BE Matched Amount</th>
                        </tr>
                        <tr>
                          <td>{statsData?.certificate_expected_count}</td>
                          <td>{statsData?.certificate_uploaded_count}</td>
                          <td>{statsData?.amount_matched_count}</td>
                          <td>{statsData?.amount_mismatched_count}</td>
                          <td>{statsData?.certificate_pending_count}</td>
                          <td>{statsData?.matched_percentage}</td>
                          <td>{statsData?.total_10bd_amount}</td>
                          <td>{statsData?.total_10be_amount_matched}</td>
                        </tr>
                    </thead>
                    </table>
                  </div> : null
                  }
                </div>
                <div style={{marginTop : "50px"}}>
                <FilterByInput nonProfitCount={totalCount} value={filters} onChange={this.filterOnChange} isNonprofitIdScreen={true}/>
                </div>
                <div className="row justify-content-end">
                  
                  <div className="col-md-12 col-12 text-right">
                    <OverlayTrigger
                      trigger="click"
                      placement={isMobile ? "bottom-end" : "left-start"}
                      overlay={this.BEImportsPopover()}
                      rootClose
                      show={this.state.showPopover}
                      onToggle={(nextShow) => this.setState({ showPopover: nextShow })} 
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        style={{width : isMobile ? "50%" : "15%", marginBottom:"10px"}}
                        onClick={(e) => {
                          this.setState({ showPopover: true });
                          this.get10BEImports(e)
                        }}
                      >
                        10BE Imports
                      </button>
                    </OverlayTrigger>
                  </div>
                  <div className="col-md-12 col-12 text-right">
                    <OverlayTrigger
                      trigger="click"
                      placement={isMobile ? "bottom-end" : "left-start"}
                      overlay={this.popover()}
                      rootClose
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        style={{width : isMobile ? "50%" : "15%"}}
                        onClick={(e) => {
                          this.getReportLinks(e, "export")
                        }}
                      >
                        Export Report
                      </button>
                    </OverlayTrigger>
                  </div>
                  <div className="col-md-12 col-12 text-right">
                    <OverlayTrigger
                      trigger="click"
                      placement={isMobile ? "bottom-end" : "left-start"}
                      overlay={this.popover("bdExportButton")}
                      rootClose
                    >
                      <button
                        type="button"
                        style={{width : isMobile ? "50%" : "15%", marginTop : "10px"}}
                        className="btn btn-secondary"
                        onClick={(e) => {
                          this.getReportLinks(e, "export", "bdExportButton");
                          this.anotherFunction(e, true);
                        }}
                        
                      >
                        Export 10BD
                      </button>
                    </OverlayTrigger>
                  </div>
                  <div className="col-md-12 col-12 text-right">
                    <button
                      className="btn btn-primary view-details-btn"
                      style={{ fontSize: "12px", margin:"10px 0 20px 0" }}
                      type="submit"
                      onClick={this.handleApproveNonprofit}
                      disabled={!this.state.onNonProfitsSelected.length > 0}
                    >
                     Approve
                    </button>
                  </div>
                </div>
                <Pagination 
                  tableHeading={tableHeading} 
                  typeOfTable={"STATUS_TABLE"} 
                  lists={donation10BdBe} 
                  loadMore={this.loadMore} 
                  count={totalCount} 
                  retrieveCheckedItems={this.retrieveCheckedItems} 
                  handleOnAllItemsSelected={this.handleOnAllItemsSelected}
                  onNonProfitsSelected={this.state.onNonProfitsSelected}
                  query={this.state.query}

                  loader={this.state.ngoDataLoader}
                />
              </div>
            </div>
          </div>
        </div>
       {
          // isUploading ? 
          // <div className="overlay" onClick={this.handleCloseOverlay}>
          // <div className="progress-container" onClick={(e) => e.stopPropagation()} >
          // <span
          //   style={{
          //     position: "absolute",
          //     top: "45%",
          //     left: "50%",
          //     transform: "translate(-50%, -50%)",
          //     color: "white",
          //     fontWeight: "bold",
          //     zIndex: 1,
          //   }}
          //     >
          //       Loading...
          //     </span>
          //     <ProgressBar
          //     animated
          //     className="custom-progress-bar"
          //     now={this.state.uploadProgress}
          //     label={`${this.state.uploadProgress}%`}
          //     variant="danger" 
          //     />
          // </div>
          // </div> :
        <Admin10BdBeUploadModal showModal={isUploadModal} setShowModal={() => this.setState({ isUploadModal: false , isUploading : false})} handleUpload={this.handleUpload} isUploading={isUploading}/> }
            <Modal
                    show={this.state.showFailurefilesModal}
                    size="md"
                    onHide={() => { this.setState({ showFailurefilesModal: false }) }}
                >
                    <Modal.Header style={{padding: "20px 26px"}}>
                        <Modal.Title className='d-flex align-items-center modalTitle' style={{fontSize:"16px"}}>
                            10BE Import Error logs
                            <span style={{fontSize:"16px", cursor:"pointer"}} onClick={() => {
                                this.setState({ showFailurefilesModal: false })
                            }}>x</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ width: '100%',
                      display: "block",
                      padding: "20px 26px",
                      background: '#FFFFFF',
                      boxSizing: 'border-box',
                      maxHeight: "500px",
                      overflowX: 'hidden',
                      overflowY: 'auto',
                      marginLeft: 'auto',
                      marginRight: 'auto'}}>
                    {}
                    {this.state.errorMessage.length > 0 ? (
                        this.state.errorMessage.map((error, idx) => (
                          <div key={idx} className="download-tag-wrapper" style={{marginBottom : "10px", fontSize:"14px", overflowWrap:"break-word"}}>
                            <span className="download-tag">{error}</span>
                          </div>
                        ))
                      ) : (
                        <p>No errors found.</p>
                      )}
                    </Modal.Body>
                </Modal >
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  donation: state.adminDonationList,
  event: state.event,
});

const mapActionToProps = (dispatch) => ({
  Donation: bindActionCreators(adminDonationListAction, dispatch),
  Event: bindActionCreators(eventAction, dispatch),
  Notification: bindActionCreators(NotificationAction, dispatch),

});

export default connect(mapStateToProps, mapActionToProps)(Admin10BdBeDonations);
